import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import DangerousOutlined from "@mui/icons-material/DangerousOutlined";
import HighlightOff from "@mui/icons-material/HighlightOff";
import HighlightOffOutlined from "@mui/icons-material/HighlightOffOutlined";
import NoteAddOutlined from "@mui/icons-material/NoteAddOutlined";
import NoteAltOutlined from "@mui/icons-material/NoteAltOutlined";
import TaskAlt from "@mui/icons-material/TaskAlt";
import TaskOutlined from "@mui/icons-material/TaskOutlined";
import Verified from "@mui/icons-material/Verified";

/**
 * Converte um registro de HistoricoAlteracoes da API em texto/ícone da linha do tempo.
 * @param {object} item — elemento de HistoricoAlteracoes
 * @param {{ solicitacao?: { StatusSolicitacao?: string } } }} [context] — dados da solicitação (ex.: para "Solicitação encerrada")
 */
export default function mapHistoricoDevolucaoTimelineEntry(item, context = {}) {
  const solicitacao = context.solicitacao;
  const rawDesc = (item.DescricaoAlteracao || "").trim();
  const descLower = rawDesc.toLowerCase();

  if (descLower.includes("solicitação criada")) {
    return {
      description: "Solicitação Cadastrada",
      icon: <AddCircleOutline color="primary" fontSize="medium" />,
    };
  }

  if (rawDesc === "Solicitação encerrada" && solicitacao?.StatusSolicitacao) {
    if (solicitacao.StatusSolicitacao === "APROVADA") {
      return {
        description: "Solicitação Aprovada",
        icon: <TaskAlt sx={{ color: "#4caf50" }} fontSize="medium" />,
      };
    }
    return {
      description: "Solicitação Rejeitada",
      icon: <HighlightOff color="error" fontSize="medium" />,
    };
  }

  if (
    descLower.includes("documento aprovado") ||
    item.StatusSolicitacao === "DOC_APROVADO"
  ) {
    return {
      description: "Documento Aprovado",
      icon: <TaskOutlined sx={{ color: "#4caf50" }} fontSize="medium" />,
    };
  }

  if (descLower.includes("solicitação reprovada")) {
    return {
      description: "Solicitação Rejeitada",
      icon: <HighlightOffOutlined color="error" fontSize="medium" />,
    };
  }

  if (descLower.includes("documentos fiscais")) {
    return {
      description: "Documentos fiscais enviados. Aguardando validação",
      icon: <NoteAddOutlined color="action" fontSize="medium" />,
    };
  }

  if (
    item.StatusSolicitacao === "DOC_REPROVADO" ||
    descLower.includes("documentos reprovados") ||
    descLower.includes("documento rejeitado")
  ) {
    return {
      description: rawDesc || "Documento Reprovado",
      icon: <DangerousOutlined color="error" fontSize="medium" />,
    };
  }

  if (descLower.includes("solicitação concluída")) {
    return {
      description: "Solicitação Concluída",
      icon: <Verified sx={{ color: "#4caf50" }} fontSize="medium" />,
    };
  }

  const isGenericAlteracao =
    descLower === "solicitação alterada" || descLower === "solicitação alterada.";

  if (isGenericAlteracao) {
    return {
      description: `Solicitação alterada por ${item.NomeUsuario}`,
      icon: <NoteAltOutlined color="action" fontSize="medium" />,
    };
  }

  if (rawDesc) {
    return {
      description: rawDesc,
      icon: <NoteAltOutlined color="action" fontSize="medium" />,
    };
  }

  return {
    description: `Solicitação alterada por ${item.NomeUsuario}`,
    icon: <NoteAltOutlined color="action" fontSize="medium" />,
  };
}
